import Notifications from 'containers/Notifications';

export default {
  exact: true,
  name: 'Notifications',
  protected: true,
  path: '/notifications',
  component: Notifications,
  permissions: ['all'],
};
